import axios from "axios";
import config from "config";
import dayjs from "dayjs";

const API_URL = config.TRAFFIC;

function formatDateTime(data) {
    if (!data) return;
    return dayjs(data).format("HH:mm, DD/MM/YYYY");
}

export async function fetchAirportTimeTable(endpoint, selectedType) {
  try {
    const response = await axios.get(`${API_URL}${endpoint}`, {
      headers: {
        "Content-Type": "application/json",
        "accept-profile": "infohub",
      },
    });
      
    const data = response.data;

      const formattedData = data.map((d) => ({
          ...d,
           time: formatDateTime(
      selectedType === "arrival" ? d.arrival_time : d.departure_time
    ),
      }));

      return formattedData;
  } catch (error) {
    console.error("Error fetching data:", error);
    return { data: null, error: error.message || "Unknown error" };
  }
}
